/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolShoppingBagIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-shopping-bag"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.85 22.8Q4.75 22.8 3.98 22.02Q3.2 21.25 3.2 20.15L3.2 8Q3.2 6.9 3.98 6.13Q4.75 5.35 5.85 5.35L7.67 5.35L7.67 5.35Q7.67 3.6 8.95 2.4Q10.22 1.2 12 1.2Q13.78 1.2 15.05 2.4Q16.32 3.6 16.32 5.35L16.32 5.35L18.15 5.35Q19.25 5.35 20.02 6.13Q20.8 6.9 20.8 8L20.8 20.15Q20.8 21.25 20.02 22.02Q19.25 22.8 18.15 22.8ZM10.32 5.35L13.68 5.35L13.68 5.35Q13.68 4.7 13.18 4.28Q12.68 3.85 12 3.85Q11.32 3.85 10.82 4.28Q10.32 4.7 10.32 5.35ZM15 11Q15 11 15.28 11Q15.55 11 15.94 10.61Q16.32 10.22 16.32 9.68L16.32 8L13.68 8L13.68 9.68Q13.68 10.22 14.06 10.61Q14.45 11 15 11ZM9 11Q9 11 9.28 11Q9.55 11 9.94 10.61Q10.32 10.22 10.32 9.68L10.32 8L7.67 8L7.67 9.68Q7.67 10.22 8.06 10.61Q8.45 11 9 11Z" fill={color} />
    </svg>
  );
}
